import React from 'react'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Spacer from '../../../Spacer'
import Text from '../../../Text'
import styles from './styles.module.css'

function ProductDetailsSectionDetail({ data = {} }) {
  const { title, text } = data

  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <Text type="h4">{title}</Text>
        </div>
        <div className={styles.textBlock}>{text && <SimpleBlockContent blocks={text} />}</div>
      </div>
    </div>
  )
}

export default ProductDetailsSectionDetail
